import { snakeize } from 'services/string_utils'

import { isSupportedCountry } from '../../advanced_settings/helpers'
import { useGetAvailabilityUserHolidaySetV4Query } from '../../api'
import { useCurrentlySupportedCountries } from '../../hooks'

export const useHolidays = () => {
  const { isLoading, data, isSuccess } = useGetAvailabilityUserHolidaySetV4Query()
  const { userCountryCode } = useCurrentlySupportedCountries()

  const holidays = isSuccess && data && isSupportedCountry(userCountryCode)
    ? snakeize(data.holidays)
    : []
  const uuid = data?.uri?.split('/')?.pop()

  return [holidays, uuid, isLoading]
}
